import { Member } from './member';

export class MemberRequest {
  public members: Member[];
  public statusMessage: string;
}
